<template>
  <v-container fluid>
    <h1 class="display-inline">Background Tasks</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <p>This interface is used to manage background tasks. If a task is not enabled, it
      will not automatically run when it is next due.</p>
    <p>If the task is scheduled with "run soon", it will run once at the next available schedule time (hourly).</p>

    <v-data-table :headers="headers" :items="tasks" dense disable-pagination hide-default-footer>
      <template v-slot:item.enabled="{ item }">
        <v-switch v-model="item.enabled" @change="changeState(item.name, item.enabled)"></v-switch>
      </template>

      <template v-slot:item.run_soon="{ item }">
        <v-switch v-model="item.run_soon" @change="changeRunSoon(item.name, item.run_soon)"></v-switch>
      </template>

      <template v-slot:item.dry_run="{ item }">
        <v-switch v-model="item.dry_run" @change="changeDryRun(item.name, item.dry_run)"></v-switch>
      </template>

      <template v-slot:item.last_run="{ item }">
        {{ new Date(item.last_run) | formatDate }}
      </template>

      <template v-slot:item.next_due="{ item }">
        {{ new Date(item.next_due) | formatDate }}
      </template>
    </v-data-table>

  </v-container>
</template>

<script>

import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "AdminBackgroundTasks",
  permissions: ["Administer Betaworkflow"],
  components: {ActiveApiCalls},
  data() {
    return {
      tasks: [],
      headers: [
        {text: "Task", value: "name"},
        {text: "Last Run", value: "last_run"},
        {text: "Next Due", value: "next_due"},
        {text: "Run Soon", value: "run_soon"},
        {text: "Dry Run", value: "dry_run"},
        {text: "Enabled", value: "enabled"},
      ],
    }
  },
  methods: {
    changeState(name, state) {
      const payload = {name: name, state: state ? 1 : 0}
      this.$BwfApi.post("admin/scheduled-tasks/change-state", payload).then(response => {
        this.roles = response
        this.$notify.toast("Saved")
      })
    },
    changeRunSoon(name, state) {
      const payload = {name: name, state: state ? 1 : 0}
      this.$BwfApi.post("admin/scheduled-tasks/run-soon", payload).then(response => {
        this.roles = response
        this.$notify.toast("Saved")
      })
    },
    changeDryRun(name, state) {
      const payload = {name: name, state: state ? 1 : 0}
      this.$BwfApi.post("admin/scheduled-tasks/dry-run", payload).then(response => {
        this.roles = response
        this.$notify.toast("Saved")
      })
    },
    loadSchedules() {
      this.$BwfApi.get("admin/scheduled-tasks").then(response => {
        this.tasks = response
      })
    }
  },
  mounted() {
    this.loadSchedules()
  },
}

</script>

<style scoped>

</style>